











































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { MenuI, translations } from '@/lang/translations';
import Search from '@/components/Partials/TopBar/Search.vue';
import User from '@/components/Partials/TopBar/User.vue';
import Cart from '@/components/Partials/TopBar/Cart.vue';

@Component({
  components: {
    Search,
    User,
    Cart,
  },
})
export default class TopBarDesktop extends Vue {
  private menu: MenuI[] = translations.pl.menu;

  private tab = null;

  clickLink = (link: string): void => {
    this.$router.push(link);
  };

  verifyIfHasSubmenu = (item: any) => {
    if (!item.sub) {
      this.$router.push(item.link);
    }
  }
}
